import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {
  DataObjectId,
  SystemStickerType,
  TimetrackerBoardSettings
} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {useForceUpdate} from '@containers/hooks'
import {Board} from '@extensions/board'
import {globals} from '@extensions/globals-base'
import {PageService} from '@extensions/page-service'
import {BoardFilters} from '@extensions/sticker/board-filters'

export const StickerMenuTimeTrackingPanel = observer(() => {
  const [, store] = useStickerStore()
  const forceUpdate = useForceUpdate()

  const filtersController = BoardFilters.stickerFilterFromBoard(
    PageService.getCurrentBoard()
  )
  const board = filtersController.getTimetrackingBoard()
  let conf = board.stickers[store.sticker.id] as TimetrackerBoardSettings
  if (!conf) {
    return <></>
  }
  if (!conf.complete || !conf.exclude) {
    conf = {complete: {}, exclude: {}}
    board.stickers[store.sticker.id] = conf
    board.commit()
    forceUpdate()
  }

  const statsClick = () => {
    Tracking.send(TrackingEvent.stickerPanelOpenTimetrackingStatistics)
    globals.openStats()
    store.closeStickerMenu()
  }

  const valueFrom = (ids: {[id: string]: number}) => {
    return Object.keys(ids)[0] || ''
  }

  const cols = Board.listColumnsOrdered(board)
    .filter(h => !h.isMirrored)
    .map(col => (
      <option value={col.id} key={col.id}>
        {col.title}
      </option>
    ))

  const onChange =
    (ids: {[id: string]: number}) =>
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const colId = e.target.value as DataObjectId
      Object.keys({...ids}).forEach(id => delete ids[id])
      if (colId) {
        ids[colId] = 1
      }
      board.commit()
      forceUpdate()
    }

  return (
    <div className="max-w-[250px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showSettings={false}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className="sti-col">
          <span className="_link" onClick={statsClick}>
            {Lang.msg.tsStats}
          </span>
        </div>
        <div className="sti-col">
          <div className="sti-col-txt">{Lang.msg.ttClosedIf}:</div>
          <select
            className="sti-col-opts"
            value={valueFrom(conf.complete)}
            onChange={onChange(conf.complete)}
          >
            <option value="" disabled={false} hidden={false}>
              —
            </option>
            {cols}
          </select>
        </div>
        <hr />
        <div className="sti-col">
          <div className="sti-col-txt">{Lang.msg.ttExcludeIf}:</div>
          <select
            className="sti-col-opts"
            value={valueFrom(conf.exclude)}
            onChange={onChange(conf.exclude)}
          >
            <option value="" disabled={false} hidden={false}>
              —
            </option>
            {cols}
          </select>
        </div>
      </div>
    </div>
  )
})
